import React from "react";
import EmailThreadList from "../../../components/email/EmailThreadList";
import {
  useAllThreadsStarredQuery,
  useUpdateStarredMutation,
  useUpdateNonActionableMutation,
  useUpdateActionableMutation
} from "../../../Services/email/EmailInbox";
import StarredFilterModal from "../../../components/email/StarredFilterModal";

const Starred = () => {
  return (
    <EmailThreadList
      useThreadsQuery={useAllThreadsStarredQuery}
      useUpdateStarredMutation={useUpdateStarredMutation}
      useUpdateNonActionableMutation={useUpdateNonActionableMutation}
      useUpdateActionableMutation={useUpdateActionableMutation}
      FilterModalComponent={StarredFilterModal}
      filterSessionKey="selectStaredFilterAndValue"
      sessionKeyPrefix="starredInitial_"
      title="Starred"
      filterKey="selectStaredFilterAndValue1"
    />
  );
};

export default Starred;

